import React from "react";

const FilterTitle = ({ title }) => {
  return <p className="mb-3 font-pop text-base font-bold uppercase">{title}</p>;
};

export default FilterTitle;
